import React from 'react';
import { Skeleton, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';

const LoaderListPod = () => {
  return (
    <Skeleton>
      <SkeletonBlock aspect="wide" />
      <SkeletonLine numberOfLines={5} />
    </Skeleton>
  );
};

const ListLoader = () => {
  return (
    <div className="sui-grid sui-col-span-6 sui-w-full">
      <SkeletonLine numberOfLines={2} />
      <div
        className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2
      md:sui-grid-cols-3 lg:sui-grid-cols-4 xl:sui-grid-cols-5 sui-gap-8"
        data-testid="plp-list-test"
      >
        {new Array(15).fill('').map((_val, i) => (
          <LoaderListPod key={`row-${i}`} />
        ))}
      </div>
    </div>
  );
};

export default ListLoader;
